<template>
  <MarketCard :class="classes.offer">
    <LinkWrapper
      :href="offerLink"
      target="_blank"
      :class="[classes.offerLink, 'offer-link']"
      @click="() => offerHandleClick()"
    >
      <OfferHeader :class="[classes.offerHeader, 'offer-header']">
        {{ offerHeader }}
      </OfferHeader>

      <OfferFittedText
        :class="classes.offerText"
        :offerText="offerText"
        :lineHeight="1.2"
      />

      <div v-if="!displayCtaButton" :class="classes.offerButtonWrapper">
        <Button :class="[classes.offerButton, 'offer-button']" />
      </div>
    </LinkWrapper>
  </MarketCard>
</template>

<script lang="ts">
import { computed, ComputedRef, defineComponent, ref } from "vue";
import MarketCard from "../../styled/MarketCard.vue";
import Button from "./Button.vue";

import OfferHeader from "../../branded/OfferHeader.vue";

import LinkWrapper from "../../LinkWrapper.vue";
import OfferFittedText from "../../OfferFittedText.vue";

import { createUseStyles } from "@fresh8/ad-data-composition/src/theme";
import { injectBrand } from "@fresh8/ad-data-composition/src/brand";

import { useGetOffer } from "../../../hooks/useDisplayOffer";
import { useShowWinnings } from "@fresh8/ad-data-composition/src/usePotentialWinnings";
import { injectCardNumber, useAnalytics } from "../../../hooks/useAnalytics";
import { Offer } from "@fresh8/types/src/betData";

const { useStyles } = createUseStyles(
  {
    offer: {
      minWidth: "0px !important"
    },
    textWrapper: {
      flex: "1 1 0",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center"
    },
    offerHeader: {
      fontSize: "21px",
      textAlign: "center",
      marginTop: "18px",
      padding: "0 8px",
      boxSizing: "border-box",
      lineHeight: 1
    },

    offerText: {
      flex: "1 1 0",
      height: "203px",
      padding: "16px 4px 4px 4px",
      overflow: "hidden",
      boxSizing: "border-box",
      flexDirection: "column",
      display: "flex",
      textAlign: "center",
      justifyContent: "center",
      position: "relative"
    },

    offerButton: {
      height: "35px !important"
    },
    offerButtonWrapper: {
      padding: "12px"
    },
    resize: {
      pointerEvents: "none",
      zIndex: -99
    },
    offerLink: {
      display: "flex",
      flex: 1,
      flexDirection: "column"
    }
  },
  undefined
);

export default defineComponent({
  name: "SkyscraperOffer",
  components: {
    MarketCard,
    Button,
    OfferFittedText,
    OfferHeader,
    LinkWrapper
  },

  setup(props) {
    const { classesRef } = useStyles(ref(props));
    const brandContext = injectBrand();
    const showWinnings = useShowWinnings();
    const displayOffer = useGetOffer() as ComputedRef<Offer>;

    const offerText = computed(
      () => displayOffer?.value && displayOffer?.value?.body
    );
    const offerHeader = computed(
      () => displayOffer.value && displayOffer.value.header
    );

    const displayCtaButton = computed(
      () =>
        !showWinnings.value &&
        brandContext?.headerBranding.value?.type === "cta"
    );
    const offerLink = computed(
      () => (displayOffer.value && displayOffer.value?.link) || "#"
    );

    const cardNumber = injectCardNumber();
    return {
      classes: classesRef,
      offerText,
      offerHeader,
      offerLink,
      displayCtaButton,
      offerHandleClick: useAnalytics({ cardNumber }, "Offer Card").handleClick
    };
  }
});
</script>

<style></style>
